import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { breakpoints, transitions } from '@/css/resources/variables.css';
import { resetButton } from '@/css/resources/placeholders.css';
import {
	fluidMargin,
	fluidValues,
	fontStyle,
} from '@/css/resources/mixins.css';

const getStyles = (styles) =>
	css({
		margin: '0px',
		// overflow: 'hidden',
		transition: `opacity ${transitions.mid} ease ${transitions.mid}`,

		'&:not(.is-ready)': {
			opacity: 0,
			'.supt-slider__slide': {
				position: 'relative',
			},
		},
		'&.no-need-navigation': {
			'.supt-slider__navigation': {
				display: 'none',
			},
			'.supt-slider__wrapper': {
				cursor: 'auto !important',
			},
		},

		'.supt-slider__container': {
			overflow: 'hidden',
			paddingTop: 25,

			[`@media (min-width: ${breakpoints.tablet})`]: {
				paddingTop: 35,
			},
		},

		'.supt-slider__wrapper': {
			position: 'relative',
			zIndex: 1,
			display: 'flex',
			alignItems: 'center',
			touchAction: 'pan-y',

			cursor: 'grab',

			'&:active': {
				cursor: 'grabbing',
				'> *': {
					pointerEvents: 'none !important' as 'none',

					'a, button': {
						pointerEvents: 'auto',
					},
				},
			},
		},

		'.supt-slider__slide': {
			flexShrink: 0,
			position: 'absolute',
			top: 0,
			left: 0,
			willChange: 'transform',
			boxSizing: 'content-box',

			img: {
				touchAction: 'pan-y',
				userSelect: 'none',
			},
		},

		'.supt-slider__controls': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			flexDirection: 'column',
		},

		'.supt-slider__navigation': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',

			'.supt-slider__button': cssObj(resetButton, {
				display: 'block',
				transition: `opacity ${transitions.mid} ease`,

				svg: cssObj(
					fluidValues(
						'width',
						styles?.navigation?.button?.width?.[0],
						styles?.navigation?.button?.width?.[1]
					),
					{
						display: 'block',
						height: 'auto',
						zIndex: '1',
						fill: styles?.navigation?.color,
					}
				),

				'&[disabled]': {
					pointerEvents: 'none',
					opacity: 0.4,
				},
			}),

			'.supt-slider__button--prev': {
				marginRight: 7,
				svg: {
					transform: 'scaleX(-1)',
				},
			},
			'.supt-slider__button--next': {
				marginLeft: 7,
			},
		},

		'.supt-slider__pagination': {
			display: 'flex',
			pointerEvents: 'none',
		},
		'.supt-slider__pagination__bullet': cssObj(
			fluidMargin(styles?.pagination?.bullets?.margin),
			{
				display: 'block',
				width: styles?.pagination?.bullets?.width,
				height: styles?.pagination?.bullets?.height,
				backgroundColor: styles?.pagination?.bullets?.backgroundColor,
				borderRadius: '50%',
				opacity: 0.5,
				transition: `opacity ${transitions.mid} ease`,

				'&.is-active': {
					opacity: 1,
				},
			}
		),
		'.supt-slider__pagination__fraction': fontStyle({
			...styles?.pagination?.fraction?.typography,
			textAlign: styles?.pagination?.fraction?.textAlignment,
			color: styles?.pagination?.fraction?.color,
		}),
	});

export { getStyles };
